export default __webpack_public_path__ + "static/media/photo--lg--52.ce6f0b83.jpg";